<div class="admin-console-wrapper">
    <h1>Admin Console</h1>
    <div class="panel-wrapper">
        <div class="panel">
            <app-feature-flags-panel [isFullAdmin]="isFullAdmin$ | async" />
        </div>
    </div>
</div>